import { useState, useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Text } from '../../components/styledComponents';
import DashboardWrapper from '../../components/dashboard/dashboardWrapper/DashboardWrapper';
import { InboundContext } from '../../context/InboundContext';
import PaymentTable from '../../components/tables/PaymentTable';
import styles from '../../styles/payments.module.css';
import {
  getCreatorCompletedPayments,
  getCreatorCompletedPaymentsForUGCCreators,
  getCreatorPendingPayments,
} from '../../services/dashboard.service';
// import CustomDatePicker from '../../components/dashboard/customDatePicker/CustomDatePicker';
import LoaderSvg from '../../assets/images/loader.svg';
import ContentSubmissionPaymentsTable from '../../components/tables/ContentSubmissionPaymentsTable';

export default function PaymentHistory() {
  const [searchParams] = useSearchParams();
  const [currentTab, setCurrentTab] = useState<string | null>(
    searchParams.get('tab') ? searchParams.get('tab') : 'pending'
  );

  const [pendingPaymentsData, setPendingPaymentsData] = useState([]);
  const [completedPaymentsData, setCompletedPaymentsData] = useState([]);
  const [totalAmountPaid, setTotalAmountPaid] = useState<number>(0);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  // const [dateRange, setDateRange] = useState<any>([]);
  // const [selectedDays, setSelectedDays] = useState<number>(7);
  // const [showDatePicker, setShowDatePicker] = useState<boolean>(false);

  const { isNonAffiliate } = useContext(InboundContext);

  const navigate = useNavigate();

  const handleTabChange = (tab: string) => {
    setCurrentTab(tab);
    navigate(`?tab=${tab}`);
  };

  const fetchPendingPayments = async () => {
    const response = await getCreatorPendingPayments();
    if (response.status) {
      setPendingPaymentsData(response.data?.pendingPayments || []);
      setIsLoading(false);
    }
  };
  const fetchCompletedPayments = async () => {
    const response = await getCreatorCompletedPayments();
    if (response.status) {
      setCompletedPaymentsData(response.data?.completedPayments);
      setIsLoading(false);
    }
  };

  const fetchCompletedPaymentsForUGC = async () => {
    const response = await getCreatorCompletedPaymentsForUGCCreators();
    if (response.status) {
      setCompletedPaymentsData(response.data?.payments);
      setTotalAmountPaid(response.data?.total_amount);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (isNonAffiliate) {
      fetchCompletedPaymentsForUGC();
    } else {
      fetchPendingPayments();
      fetchCompletedPayments();
    }
  }, [isNonAffiliate]);

  return (
    <DashboardWrapper heading="Payment History">
      {!isNonAffiliate && (
        <div className="top-bar">
          <div className={styles.tabsContainer}>
            <Text
              fontSize="14px"
              color={currentTab === 'pending' ? 'var(--saral-purple)' : 'var(--dark-grey)'}
              onClick={() => handleTabChange('pending')}
            >
              Pending
            </Text>
            <span>|</span>
            <Text
              fontSize="14px"
              color={currentTab === 'completed' ? 'var(--saral-purple)' : 'var(--dark-grey)'}
              onClick={() => handleTabChange('completed')}
            >
              Completed
            </Text>
          </div>
          <div>
            {/* <CustomDatePicker
            selectedDays={selectedDays}
            showDatePicker={showDatePicker}
            dateRange={dateRange}
            setDateRange={setDateRange}
            setSelectedDays={setSelectedDays}
            setShowDatePicker={setShowDatePicker}
          /> */}
          </div>
        </div>
      )}

      {isLoading ? (
        <div className={styles.loaderDiv}>
          <img src={LoaderSvg} alt="loader" width={100} />
        </div>
      ) : (
        <>
          {isNonAffiliate && (
            <ContentSubmissionPaymentsTable tableBody={completedPaymentsData} totalAmountPaid={totalAmountPaid} />
          )}
          {currentTab === 'pending' && !isNonAffiliate && (
            <PaymentTable tableBody={pendingPaymentsData} currentTab={currentTab} />
          )}
          {currentTab === 'completed' && !isNonAffiliate && (
            <PaymentTable tableBody={completedPaymentsData} currentTab={currentTab} />
          )}
        </>
      )}
    </DashboardWrapper>
  );
}
